/* THE ILLUMINATEE - mobile Sort drawer.
   Replaces the native sort <select> with a plain tappable list under "Sort". */
(function () {
  'use strict';
  function relabel () {
    document.querySelectorAll('.facets-toggle, .facets-toggle__button').forEach(function (btn) {
      if (btn.setAttribute) btn.setAttribute('aria-label', 'Sort');
      Array.prototype.forEach.call(btn.childNodes, function (node) {
        if (node.nodeType !== 3) return;
        var t = (node.nodeValue || '').trim();
        if (/^filter and sort$/i.test(t) || /^filter$/i.test(t)) {
          node.nodeValue = node.nodeValue.replace(t, 'Sort');
        }
      });
      btn.querySelectorAll('span, div').forEach(function (s) {
        if (s.childElementCount === 0) {
          var t = (s.textContent || '').trim();
          if (/^filter and sort$/i.test(t) || /^filter$/i.test(t)) s.textContent = 'Sort';
        }
      });
    });
  }
  function buildSortList () {
    var drawer = document.querySelector('.facets--drawer');
    if (!drawer) return;
    var sel = drawer.querySelector('.sorting-filter__container[class*="desktop:hidden"] select[name="sort_by"]')
           || drawer.querySelector('select[name="sort_by"]');
    if (!sel) return;
    var container = sel.closest('.sorting-filter__container') || sel.closest('.sorting-filter');
    if (!container) return;
    var list = container.querySelector('.ill-sortlist');
    if (list) {
      Array.prototype.forEach.call(list.children, function (b) {
        var on = b.getAttribute('data-value') === sel.value;
        b.classList.toggle('is-current', on);
        b.setAttribute('aria-current', on ? 'true' : 'false');
      });
      return;
    }
    list = document.createElement('div');
    list.className = 'ill-sortlist';
    Array.prototype.forEach.call(sel.options, function (opt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ill-sortlist__item';
      b.setAttribute('data-value', opt.value);
      b.textContent = opt.textContent.trim();
      if (opt.value === sel.value) { b.classList.add('is-current'); b.setAttribute('aria-current', 'true'); }
      b.addEventListener('click', function () {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', opt.value);
        location.href = u.toString();
      });
      list.appendChild(b);
    });
    var wrap = sel.closest('.sorting-filter__select-wrapper') || sel;
    wrap.parentNode.insertBefore(list, wrap.nextSibling);
  }
  function apply () { relabel(); buildSortList(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; apply(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
